import { render, staticRenderFns } from "./FooterContainer.vue?vue&type=template&id=082ea1c4&scoped=true"
import script from "./FooterContainer.vue?vue&type=script&lang=js"
export * from "./FooterContainer.vue?vue&type=script&lang=js"
import style0 from "./FooterContainer.vue?vue&type=style&index=0&id=082ea1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082ea1c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
